
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import Mixin from '../../mixin'
import { db } from '@/main'


@Component({})
export default class Settings extends mixins(Mixin) {
  freePremiumDays = 0
  isFreePremiumEnabled = false
  monthPriceCop = 0
  monthPriceUsd = 0
  monthlyPriceId = ''
  yearPriceCop = 0
  yearPriceUsd = 0
  yearPriceId = ''
  validForm = true

  initFreePremiumDays = 0
  initIsFreePremiumEnabled = false
  initMonthPriceCop = 0
  initMonthPriceUsd = 0
  initMonthlyPriceId = ''
  initYearPriceCop = 0
  initYearPriceUsd = 0
  initYearPriceId = ''



  //rules
  textFieldRules = [v => !!v || 'Este campo es requerido']

  mounted() {
    this.listenInfoData()
  }

  listenInfoData() {
    try {
      db.collection('info')
        .doc('data')
        .onSnapshot(doc => {
          const infoData = doc.data() ?? ''
          this.freePremiumDays = infoData['free_premium_days']
          this.initFreePremiumDays = this.freePremiumDays
          this.isFreePremiumEnabled = infoData['is_free_premium_enable']
          this.initIsFreePremiumEnabled = this.isFreePremiumEnabled
          this.monthPriceCop = infoData['month_price_cop']
          this.initMonthPriceCop = this.monthPriceCop
          this.monthPriceUsd = infoData['month_price_usd']
          this.initMonthPriceUsd = this.monthPriceUsd
          this.monthlyPriceId = infoData['monthly_price_id']
          this.initMonthlyPriceId = this.monthlyPriceId
          this.yearPriceCop = infoData['year_price_cop']
          this.initYearPriceCop = this.yearPriceCop
          this.yearPriceUsd = infoData['year_price_usd']
          this.initYearPriceUsd = this.yearPriceUsd
          this.yearPriceId = infoData['yearly_price_id']
          this.initYearPriceId = this.yearPriceId
        })
    } catch (error) {
      console.log('Error listenInfoData ' + error)
    }
  }

  async updateInfoData() {
    try {
        this.showNotification('loading');
      const infoToUpdate = {}
      if (this.freePremiumDays != this.initFreePremiumDays) {
        infoToUpdate['free_premium_days'] =parseInt(this.freePremiumDays.toString());
      }
      if (this.isFreePremiumEnabled != this.initIsFreePremiumEnabled) {
        infoToUpdate['is_free_premium_enable'] = this.isFreePremiumEnabled
      }
      if (this.monthPriceCop != this.initMonthPriceCop) {
        infoToUpdate['month_price_cop'] = parseInt(this.monthPriceCop.toString());
      }
      if (this.monthPriceUsd != this.initMonthPriceUsd) {
        infoToUpdate['month_price_usd'] =parseFloat(this.monthPriceUsd.toString());
      }
      if (this.monthlyPriceId != this.initMonthlyPriceId) {
        infoToUpdate['monthly_price_id'] = this.monthlyPriceId;
      }
      if (this.yearPriceCop != this.initYearPriceCop) {
        infoToUpdate['year_price_cop'] = parseInt(this.yearPriceCop.toString());
      }
      if (this.yearPriceUsd != this.initYearPriceUsd) {
        infoToUpdate['year_price_usd'] = parseFloat(this.yearPriceUsd.toString());
      }
      if (this.yearPriceId != this.initYearPriceId) {
        infoToUpdate['yearly_price_id'] = this.yearPriceId
      }
      await db
        .collection('info')
        .doc('data')
        .update(infoToUpdate)
      this.showNotification('success')
    } catch (error) {
      console.log('Error updateInfoData ' + error)
      this.showNotification('fail');
    }
  }
}
